import styles from './LoadingSpinner.module.scss';

export type LoadingSpinnerProps = {
  margin?: string;
  top?: string;
  left?: string;
  size?: `${string}rem` | `${string}em`;
  radius?: string;
  color?: string;
  thickness?: string;
  noWrapper?: boolean;
  className?: string;
  'data-testid'?: string;
};

const LoadingSpinner = ({
  radius = '20',
  color = '#000',
  size = '3rem',
  top = 'auto',
  left = 'auto',
  margin = '0',
  thickness = '3',
  noWrapper = false,
  className = '',
  ...rest
}: LoadingSpinnerProps) => {
  const renderSvg = () => (
    <svg {...rest} className={styles.spinner} viewBox="0 0 50 50" style={{ width: size, top, left, margin }}>
      <circle className={styles.path} style={{ stroke: color }} cx="25" cy="25" r={radius} fill="none" strokeWidth={thickness} />
    </svg>
  );
  return noWrapper ? <>{renderSvg()}</> : <div className={`${styles.spinnerWrapper} ${className || ''}`}>{renderSvg()}</div>;
};

export default LoadingSpinner;
